<div class="modal-content">
    <div class="modal-header">
        <button class="close" type="button" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">Open Service</h4>
    </div>

    <div class="modal-body">
        <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
        "Edit Mode" will <strong>assign the service to you</strong> where "View-only" will not.
    </div>

    <div class="modal-footer">
        <div class="btn--group">
            <button type="button" class="btn--default" data-bs-dismiss="modal" (click)="viewTransaction()">View-only</button>
            <button type="button" class="btn--primary" data-bs-dismiss="modal" (click)="redirectToTransaction()" [disabled]="!loaded">Edit Mode</button>
        </div>
    </div>
</div>